import { AxiosError } from 'axios';
import axiosInstance from '../../config/axiosInstance';
import { baseAxiosInstance } from '../../config/baseAxiosInstance';
import { ERRORS } from '../../constants/error';
import { ROUTES } from '../../constants/routes';

let errorCount = 0;

export const checkTokenValidity = async (token: string): Promise<boolean> => {
  try {
    // Backend returns `true` / `false` with HTTP 200 — never throws on an
    // invalid/expired token. We must read the response body, not just rely
    // on the request not throwing.
    const isValid = await baseAxiosInstance.post<unknown, boolean>(
      '/auth/verify-token',
      { token },
    );
    return isValid === true;
  } catch (error) {
    if (error instanceof AxiosError && error.code === ERRORS.ERR_NETWORK) {
      errorCount++;
      if (errorCount === 10) {
        window.location.href = `/${ROUTES.SERVICE_UNAVAILABLE}`;
      }
    }
    return false;
  }
};

export const checkDashboardAccess = async () => {
  try {
    await axiosInstance.get('/auth/dashboard-permission');
    return true;
  } catch {
    return false;
  }
};
